import { getEnvConfig } from '@praxis/component-runtime-env'

const imageHosts = {
  oldHost: process.env.REACT_APP_OLD_IMAGE_HOST || '',
  newHost: process.env.REACT_APP_NEW_IMAGE_HOST || '',
}

const getRuntimeConfigPath = () =>
  process.env.NODE_ENV === 'development' ? '/config.json' : '/app-environment'

const readHosts = (env = {}) => ({
  oldHost:
    env.REACT_APP_OLD_IMAGE_HOST ||
    env.OLD_IMAGE_HOST ||
    process.env.REACT_APP_OLD_IMAGE_HOST ||
    '',
  newHost:
    env.REACT_APP_NEW_IMAGE_HOST ||
    env.NEW_IMAGE_HOST ||
    process.env.REACT_APP_NEW_IMAGE_HOST ||
    '',
})

const loadRuntimeHosts = () => {
  if (typeof getEnvConfig !== 'function') return

  getEnvConfig(getRuntimeConfigPath())
    .then((env = {}) => {
      const { oldHost = '', newHost = '' } = readHosts(env)
      if (oldHost) imageHosts.oldHost = oldHost
      if (newHost) imageHosts.newHost = newHost
    })
    .catch(() => {})
}

const getImageHosts = () => imageHosts

loadRuntimeHosts()

function transformImageUrl(url) {
  if (!url || typeof url !== 'string') return url

  const { oldHost, newHost } = getImageHosts()
  if (!oldHost || !newHost) return url
  if (!url.includes(oldHost)) return url

  return url.replace(oldHost, newHost)
}

const srcDescriptor = Object.getOwnPropertyDescriptor(
  HTMLImageElement.prototype,
  'src'
)

const isExternal = process.env.REACT_APP_ENV?.startsWith('pol_')

if (srcDescriptor && isExternal) {
  Object.defineProperty(HTMLImageElement.prototype, 'src', {
    get() {
      return srcDescriptor.get.call(this)
    },
    set(value) {
      srcDescriptor.set.call(this, transformImageUrl(value))
    },
  })
}
